import React, { useEffect } from 'react'
import { Box } from '@mui/material'
import { NodeView } from './NodeView'
import { WorkingTree } from './CurriculaTree'
import { useSetAtom } from 'infrastructure/state/jotai.wrapper'
import { workingTreeAtom } from './atoms'
import { useGetTreeById } from 'shared/hooks/trees/hooks'
import { normalizeTreeForJsonView } from './utility'

// This is the entry point into the component, the top of the tool component hierarchy
export function TreeEditingV2(ids: { treeId: string; versionId: string }) {
  const { tree, resetTree } = useGetTreeById(ids)
  const setTree = useSetAtom(workingTreeAtom)

  useEffect(() => {
    setTree({
      tree: tree && normalizeTreeForJsonView(tree),
      resetTree,
    })
  }, [tree])

  return (
    <Box>
      <WorkingTree />
      <NodeView />
    </Box>
  )
}
